import { ReactNode } from 'react';
import cn from 'classnames';
import styles from './ContentPageContent.module.scss';

interface ContentPageContentProps {
  classNames?: string | string[];
  children: ReactNode;
}

const ContentPageContent = ({
  classNames,
  children,
}: ContentPageContentProps) => (
  <article className={cn(styles.contentPageContent, classNames)}>
    {children}
  </article>
);

export default ContentPageContent;
